import { Link } from 'react-router-dom';

export const XED21_LOGO_SRC = '/Xed21_Logo.png';

type Xed21LogoSize = 'sm' | 'md' | 'lg';

interface Xed21LogoProps {
  size?: Xed21LogoSize;
  className?: string;
  imageClassName?: string;
  onClick?: () => void;
}

const sizeClasses: Record<Xed21LogoSize, string> = {
  sm: 'h-8',
  md: 'h-10',
  lg: 'h-12',
};

export default function Xed21Logo({
  size = 'md',
  className = '',
  imageClassName = '',
  onClick,
}: Xed21LogoProps) {
  return (
    <Link
      to="/"
      aria-label="Xed21 home"
      onClick={onClick}
      className={`inline-flex shrink-0 items-center ${className}`}
    >
      <img
        src={XED21_LOGO_SRC}
        alt="Xed21"
        width={1077}
        height={329}
        className={`${sizeClasses[size]} w-auto object-contain ${imageClassName}`}
      />
    </Link>
  );
}
